/* iTOVi — UI interactions: reveals, sticky header, scanflow trigger, mobile nav */
(function(){
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Sticky header state
  const header = document.querySelector('.site-header');
  const onScroll = () => header && header.classList.toggle('scrolled', window.scrollY > 8);
  onScroll();
  window.addEventListener('scroll', onScroll, { passive:true });

  // Reveal on scroll
  const reveal = document.querySelectorAll('.reveal');
  if (reduce || !('IntersectionObserver' in window)) {
    reveal.forEach(el => el.classList.add('in'));
  } else {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting){
          const el = e.target;
          const delay = parseInt(el.dataset.delay || '0', 10);
          setTimeout(() => el.classList.add('in'), delay);
          io.unobserve(el);
        }
      });
    }, { threshold:0.16, rootMargin:'0px 0px -8% 0px' });
    reveal.forEach(el => io.observe(el));
  }

  // Scan→report: play when in view
  const stage = document.querySelector('.scan-stage');
  if (stage){
    if (reduce) { stage.classList.add('live'); }
    else {
      const so = new IntersectionObserver((entries) => {
        entries.forEach(e => { if (e.isIntersecting){ stage.classList.add('live'); so.unobserve(e.target); } });
      }, { threshold:0.4 });
      so.observe(stage);
    }
  }

  // Buy / Subscribe toggle on product cards (visual only in prototype)
  document.querySelectorAll('.buysub').forEach(t => {
    t.addEventListener('click', (ev) => {
      const span = ev.target.closest('span'); if(!span) return;
      t.querySelectorAll('span').forEach(s => s.classList.remove('on'));
      span.classList.add('on');
      const card = t.closest('.product-card, .buybox');
      const price = card && card.querySelector('[data-buy]');
      if (price){
        const mode = span.dataset.mode;
        price.querySelector('.price').textContent = price.dataset[mode];
        price.querySelector('.per').textContent = mode === 'sub' ? '/mo' : 'one-time';
      }
    });
  });

  // Hero video — respect reduced motion (poster stays, no playback)
  const heroVideo = document.querySelector('.hero-video');
  if (heroVideo && reduce){ heroVideo.removeAttribute('autoplay'); heroVideo.pause && heroVideo.pause(); }

  // "Hundreds → the right few" dot-cloud — a dense muted field with a few highlighted.
  // Dots are generated from data attributes; final state is the default (always renders);
  // JS replays the highlight animation as a progressive enhancement.
  document.querySelectorAll('.cloud').forEach(cloud => {
    const count = +(cloud.dataset.count || 96);
    const cols  = +(cloud.dataset.cols || 12);
    const hits  = (cloud.dataset.hits || '').split(',').map(s => +s).filter(n => !isNaN(n));
    cloud.style.setProperty('--cols', cols);
    if (!cloud.querySelector('.pd')){
      const frag = document.createDocumentFragment();
      for (let i = 0; i < count; i++){
        const s = document.createElement('span');
        s.className = 'pd' + (hits.includes(i) ? ' hit' : '');
        s.style.setProperty('--i', i);
        frag.appendChild(s);
      }
      cloud.appendChild(frag);
    }
    if (reduce) return;                 // no animation; default state shows
    cloud.classList.add('anim');        // start: full muted field, no highlight
    const release = () => cloud.classList.remove('anim');
    if ('IntersectionObserver' in window){
      const co = new IntersectionObserver((entries) => {
        entries.forEach(e => { if (e.isIntersecting){ release(); co.disconnect(); } });
      }, { threshold:0.2 });
      co.observe(cloud);
    } else { release(); }
  });

  // FAQ accordion
  document.querySelectorAll('.faq-q').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const ans = item.querySelector('.faq-a');
      const open = item.classList.toggle('open');
      btn.setAttribute('aria-expanded', String(open));
      ans.style.maxHeight = open ? ans.scrollHeight + 'px' : '0';
    });
  });

  // "Hundreds → the few": scroll-scrubbed zoom into the highlighted bottles + dim the rest
  const narrowMedia = [...document.querySelectorAll('.narrow-media')];
  if (narrowMedia.length){
    if (reduce){
      narrowMedia.forEach(m => { const i=m.querySelector('.narrow-img'); const d=m.querySelector('.narrow-dim'); if(i) i.style.transform='scale(1.5)'; if(d) d.style.opacity='.6'; });
    } else {
      const updateNarrow = () => {
        const vh = window.innerHeight;
        narrowMedia.forEach(m => {
          const img = m.querySelector('.narrow-img'); if (!img) return;
          const dim = m.querySelector('.narrow-dim');
          const r = m.getBoundingClientRect();
          let p = (vh * 0.82 - r.top) / (vh * 0.62);   // 0 entering bottom → 1 once centered/up
          p = Math.max(0, Math.min(1, p));
          img.style.transform = 'scale(' + (1 + p * 1.35).toFixed(3) + ')';
          if (dim) dim.style.opacity = (p * 0.9).toFixed(3);
        });
      };
      window.addEventListener('scroll', updateNarrow, { passive:true });
      window.addEventListener('resize', updateNarrow, { passive:true });
      updateNarrow();
    }
  }

  // PDP package/variant selector → updates price + CTA label
  document.querySelectorAll('.variants').forEach(group => {
    const buybox = group.closest('.buybox') || document;
    const priceEl = buybox.querySelector('.price-row .price');
    const perEl = buybox.querySelector('.price-row .per');
    const cta = buybox.querySelector('[data-cta]');
    group.querySelectorAll('.variant').forEach(v => {
      v.addEventListener('click', () => {
        const input = v.querySelector('input'); if (input) input.checked = true;
        group.querySelectorAll('.variant').forEach(x => x.classList.remove('on'));
        v.classList.add('on');
        if (priceEl && input) priceEl.textContent = input.dataset.price;
        if (perEl && input) perEl.textContent = input.dataset.per;
        if (cta && input) cta.textContent = input.dataset.label;
      });
    });
  });

  // Mobile nav — open/close dropdown, swap icon, close on link tap or Escape
  const toggle = document.querySelector('.nav-toggle');
  const nav = document.querySelector('.nav');
  if (toggle && nav){
    const ICON_MENU = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M3 12h18M3 18h18" stroke-linecap="round"/></svg>';
    const ICON_CLOSE = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 5l14 14M19 5 5 19" stroke-linecap="round"/></svg>';
    const setOpen = (open) => {
      nav.classList.toggle('open', open);
      toggle.setAttribute('aria-expanded', String(open));
      toggle.innerHTML = open ? ICON_CLOSE : ICON_MENU;
    };
    toggle.addEventListener('click', () => setOpen(!nav.classList.contains('open')));
    nav.querySelectorAll('a').forEach(a => a.addEventListener('click', () => setOpen(false)));

    // Dropdown submenus (Scanners / Learn)
    const closeGroups = (except) => nav.querySelectorAll('.nav-group.open').forEach(g => {
      if (g === except) return;
      g.classList.remove('open');
      const b = g.querySelector('.nav-sub-toggle'); if (b) b.setAttribute('aria-expanded', 'false');
    });
    nav.querySelectorAll('.nav-sub-toggle').forEach(btn => {
      const group = btn.closest('.nav-group');
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const willOpen = !group.classList.contains('open');
        closeGroups(group);
        group.classList.toggle('open', willOpen);
        btn.setAttribute('aria-expanded', String(willOpen));
      });
    });
    document.addEventListener('click', (e) => { if (!e.target.closest('.nav-group')) closeGroups(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape'){ setOpen(false); closeGroups(); } });
  }
})();
